import React, { useState } from "react";
import "../../css/berMonths.css";
import bg1 from "../../assets/images/DJI_20250621082021_0024_D-enhanced.jpg";

const promos = [
  {
    title: "Fisherman for a day",
    subtitle: "Experience Life as a Local Fisherman",
    image: bg1,
    buttonText: "Book Now",
    serviceId: "68a8a253f292262187a00f27",
    encodedTitle: "Fisherman%20for%20a%20Day"
  },
];

const BerMonths = () => {
  return (
    <div className="ber-months">
        <div className="container">
            <div className="ber-months-inner">
            {promos.map((promo, index) => (
                <div
                key={index}
                className="ber-months-bg"
                style={{ 
                  backgroundImage: `url("${promo.image}")`,
                }}
                >
                <div className="promo-box">
                    <h2>{promo.title}</h2>
                    <p>{promo.subtitle}</p>
                    <button 
                      className="book-btn"
                      onClick={() => {
                        const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
                        const protocol = frontendUrl?.startsWith('http') ? '' : 'https://';
                        const bookingUrl = `${protocol}${frontendUrl}/booking?serviceId=${promo.serviceId}&title=${promo.encodedTitle}`;
                        window.open(bookingUrl, '_blank');
                      }}
                    >
                      {promo.buttonText}
                    </button>
                </div>
                </div>
            ))}
            </div>
        </div>
    </div>
  );
};

export default BerMonths;